import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X } from '../utils/icons';
import { FaDiscord } from 'react-icons/fa';
import { useI18n } from '../i18n';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t, lang, setLang } = useI18n();

  const navItems = [
    { name: t('nav.services'), path: '/services' },
    { name: t('nav.projects'), path: '/projects' },
    { name: t('nav.about'), path: '/about' },
    { name: t('nav.blog'), path: '/blog' },
  ];

  const toggleLanguage = () => setLang(lang === 'en' ? 'es' : 'en');

  return (
    <motion.nav
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className="nav-surface fixed w-full z-50"
    >
      <div className="ccc-container flex h-20 items-center justify-between">
        <Link to="/" className="flex items-center gap-3 text-white" onClick={() => setIsOpen(false)}>
          <img src="/images/badges/crespo-15.png" alt="CrespoCyberConsulting Logo" className="h-11 w-auto" />
          <span className="hidden border-l border-white/15 pl-3 text-[0.65rem] font-black uppercase tracking-[0.18em] text-white/60 lg:block">
            {t('ui.securityEngineering')}
          </span>
        </Link>

        <div className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              className={({ isActive }) => `ccc-nav-link ${isActive ? 'is-active' : ''}`}
            >
              {item.name}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="https://discord.gg/mnCyXtzqyU"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={t('nav.discordAriaLabel')}
            className="ccc-nav-cta"
          >
            <FaDiscord className="h-4 w-4" />
            {t('nav.discord')}
          </a>
          <button
            onClick={toggleLanguage}
            className="ccc-nav-cta"
            aria-label="Toggle language"
          >
            {lang === 'en' ? 'Español' : 'English'}
          </button>
        </div>

        <button
          onClick={() => setIsOpen((open) => !open)}
          className="text-white md:hidden"
          aria-label={isOpen ? t('nav.closeMenu') : t('nav.openMenu')}
          aria-expanded={isOpen}
        >
          {isOpen ? <X className="h-8 w-8" /> : <Menu className="h-8 w-8" />}
        </button>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.22 }}
            className="border-t border-white/10 bg-[#111816] md:hidden"
          >
            <div className="ccc-container flex flex-col gap-4 py-5">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={({ isActive }) => `ccc-nav-link text-base ${isActive ? 'is-active' : ''}`}
                >
                  {item.name}
                </NavLink>
              ))}
              <a
                href="https://discord.gg/mnCyXtzqyU"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                aria-label={t('nav.discordAriaLabel')}
                className="ccc-nav-cta w-fit"
              >
                <FaDiscord className="h-4 w-4" />
                {t('nav.discord')}
              </a>
              <button
                onClick={() => { toggleLanguage(); setIsOpen(false); }}
                className="ccc-nav-cta w-fit"
              >
                {lang === 'en' ? 'Español' : 'English'}
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
